import React from "react";
import { useLocation } from "react-router-dom";
import Index from "./Index";
import HistoryModern from "./HistoryModern";

// Historial de partidas: la pantalla nueva. Las repeticiones (también las que se
// abren desde el Campeonato) siguen usando la ventana de repetición de siempre.
const History = () => {
  const location = useLocation();
  if (location.state?.openReplayMatch || location.state?.replayActive) return <Index forcedTab="history" />;
  return <HistoryModern />;
};

export default History;
